var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.519,
    height: 28.694,
    viewBox: "0 0 32.519 28.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls{fill:\"current\";}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls",
    d: "M214.647,191.141H199.531a.476.476,0,0,0,0,.953h15.116a.476.476,0,0,0,0-.953Z",
    transform: "translate(-186.412 -180.913)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls",
    d: "M214.647,248.474H199.531a.476.476,0,0,0,0,.953h15.116a.476.476,0,1,0,0-.953Z",
    transform: "translate(-186.412 -234.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls",
    d: "M214.647,305.807H199.531a.476.476,0,0,0,0,.953h15.116a.476.476,0,1,0,0-.953Z",
    transform: "translate(-186.412 -288.297)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls",
    d: "M160.023,125.549H141.881a2.774,2.774,0,0,0-2.771,2.771v11.408a2.774,2.774,0,0,0,2.771,2.771H154.6a.439.439,0,0,1,.347.168l4.106,5.2a.818.818,0,0,0,.645.317.843.843,0,0,0,.277-.047.819.819,0,0,0,.557-.783v-4.9a2.783,2.783,0,0,0,2.264-2.723V128.32A2.774,2.774,0,0,0,160.023,125.549Zm1.818,14.179a1.824,1.824,0,0,1-1.794,1.817.476.476,0,0,0-.47.476v4.973l-3.885-4.919a1.386,1.386,0,0,0-1.094-.53H141.881a1.82,1.82,0,0,1-1.818-1.818V128.32a1.82,1.82,0,0,1,1.818-1.818h18.142a1.82,1.82,0,0,1,1.818,1.818Z",
    transform: "translate(-130.275 -119.487)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls",
    d: "M7.018,44.048a1.27,1.27,0,0,0-.822.472L2.924,48.663V44.511a.476.476,0,0,0-.47-.476,1.526,1.526,0,0,1-1.5-1.52V32.584a1.523,1.523,0,0,1,1.521-1.521H18.267a1.523,1.523,0,0,1,1.521,1.521v1.838a.476.476,0,0,0,.953,0V32.584a2.476,2.476,0,0,0-2.474-2.474H2.474A2.476,2.476,0,0,0,0,32.584v9.931a2.485,2.485,0,0,0,1.971,2.421v4.215a.774.774,0,0,0,.526.74.8.8,0,0,0,.262.045.774.774,0,0,0,.61-.3l3.575-4.526a.321.321,0,0,1,.208-.12.476.476,0,1,0-.134-.943Z",
    transform: "translate(0 -30.11)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.6a29ec8c.svg";
export { ForwardRef as ReactComponent };